import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type StatusFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const StatusFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: StatusFilledProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-3.333336 -3.333336) scale(1.277778)',
        },
        [
          h(
            'path',
            {
              "fill-rule": 'evenodd',
              "clip-rule": 'evenodd',
              d: 'M5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364ZM8.33135 7.04543C8.45191 6.92487 8.61543 6.85714 8.78592 6.85714H15.2145C15.385 6.85714 15.5485 6.92487 15.6691 7.04543C15.7896 7.16599 15.8574 7.3295 15.8574 7.5C15.8574 7.6705 15.7896 7.83401 15.6691 7.95457C15.5485 8.07513 15.385 8.14286 15.2145 8.14286C15.2145 9.77957 14.3788 11.2131 13.4402 12C14.3788 12.7869 15.2145 14.2204 15.2145 15.8571C15.385 15.8571 15.5485 15.9249 15.6691 16.0454C15.7896 16.166 15.8574 16.3295 15.8574 16.5C15.8574 16.6705 15.7896 16.834 15.6691 16.9546C15.5485 17.0751 15.385 17.1429 15.2145 17.1429H8.78592C8.61543 17.1429 8.45191 17.0751 8.33135 16.9546C8.2108 16.834 8.14307 16.6705 8.14307 16.5C8.14307 16.3295 8.2108 16.166 8.33135 16.0454C8.45191 15.9249 8.61543 15.8571 8.78592 15.8571C8.78592 14.2204 9.62164 12.7869 10.5602 12C9.62164 11.2131 8.78592 9.77957 8.78592 8.14286C8.61543 8.14286 8.45191 8.07513 8.33135 7.95457C8.2108 7.83401 8.14307 7.6705 8.14307 7.5C8.14307 7.3295 8.2108 7.16599 8.33135 7.04543Z',
              fill: color,
            },
          ),
        ],
      ),
    ],
  );

export default StatusFilled;
